import { observer } from "mobx-react-lite"
import { forwardRef, useEffect, useRef } from "react";

const AutoTextArea = forwardRef(({ save, value, setValue, active }, ref) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (typeof ref === 'function') {
            ref(textareaRef.current);
        } else if (ref) {
            ref.current = textareaRef.current;
        }
    }, [ref]);
    useEffect(() => {
        if (!textareaRef.current) return;
        
        const textarea = textareaRef.current;
        const computedStyle = window.getComputedStyle(textarea);
        const paddingTop = parseInt(computedStyle.paddingTop, 10);
        const paddingBottom = parseInt(computedStyle.paddingBottom, 10);

        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
    }, [value, active]);

    return (
        <textarea
            ref={textareaRef}
            value={value}
            onChange={(event) => {
                setValue(event.target.value)
                textareaRef.current.className = event.target.value.replaceAll(" ", "") == "" ? "error" : "";
            }}
            rows={1}
            onKeyDown={(event) => event.key === "Enter" && save()}
        />
    );
});

export default observer(AutoTextArea);
